<template>
	<section id="id-app-catalog-categories" class="app-catalog-categories">
		<h2 class="app-catalog-categories__title">{{ $t('catalog') }}</h2>
		<div class="app-catalog-categories-tabs">
			<ul class="app-catalog-tabs__list">
				<li v-if="isNewCourses">
					<button
						@click="showNewCourses($event)"
						class="app-catalog-tabs__btn app-catalog-tabs__btn--new is-active"
						type="button"
					>{{ $t('new_courses') }}</button>
				</li>
				<li v-for="(category, index) in categories" :key="'category-' + category.id">
					<button
						@click="showCategoriesCourses(category.id, $event)"
						class="app-catalog-tabs__btn"
						:class="{ 'is-active': !isNewCourses && index === 0 }"
						type="button"
					>{{ category.title }}</button>
				</li>
			</ul>
		</div>
		<div v-if="courses.length" class="app-catalog-categories__courses">
			<p class="app-catalog-categories__courses-count">{{ $t('found_courses', { count: courses.length }) }}</p>
			<ul
				class="app-catalog-categories__courses-list"
				:class="{
					'is-show-more': isShowMoreCourses
				}"
			>
				<li v-for="(course, index) in courses" :key="'catalog-course-' + course.id + '-' + index" class="app-catalog-categories__courses-item">
					<AppCatalogCourse
						:course="course"
						:full_only="false"
						:finished="course.finished"
						:started="course.active"
						:bookmark="course.wished"
					/>
				</li>
			</ul>

			<div v-if="courses.length > 8" class="app-catalog-categories__bottom">
				<button @click="showCourses" class="app-btn app-btn--round app-btn--outline" type="button">
					{{ isShowMoreCourses ? $t('buttons.show_less') : $t('buttons.show_more') }}
				</button>
			</div>
		</div>
		<div v-else class="app-catalog-categories__message-holder">
			<p class="app-catalog-categories__message">
				{{ $t('messages.no_filters_message') }}
			</p>
		</div>
	</section>
</template>

<script>
import AppCatalogCourse from './Catalog/AppCatalogCourse.vue';

export default {
	name: "AppCatalogCategories",

	components: {
		AppCatalogCourse
	},

	props: {
		categories: Array,
		current_company_url: '',
		newest_courses: Object
	},

	data() {
		return {
			courses: [],
			tabsElements: [],
			isShowMoreCourses: false
		};
	},

	mounted() {
		this.courses = this.isNewCourses ? this.newest_courses.courses : this.categories[0].courses;
		this.tabsElements = document.querySelectorAll('.app-catalog-tabs__btn');
	},

	computed: {
		isNewCourses() {
			return (this.current_company_url === 'mega' || this.current_company_url === 'soft-skills' || this.current_company_url === 'scorm') ? false : true;
		}
	},

	methods: {
		showCategoriesCourses(categoryId, e) {
			const category = this.categories.filter((category) => category.id === categoryId);

			this.courses = category[0].courses;

			this.tabsElements.forEach(el => {
				el.classList.remove('is-active')
			});

			e.currentTarget.classList.add('is-active');
		},

		showNewCourses(e) {
			this.courses = this.newest_courses.courses;

			this.tabsElements.forEach(el => {
				el.classList.remove('is-active')
			});

			e.currentTarget.classList.add('is-active');
		},

		showCourses() {
			this.isShowMoreCourses = !this.isShowMoreCourses;
		}
	}
};
</script>
